var render = function render(){var _vm=this,_c=_vm._self._c;return _c('excel-export',{attrs:{"data":_vm.items,"fields":_vm.excelFields,"worksheet":"Documentos","name":"documentos_compliance.xlsx"}})
}
var staticRenderFns = []

export { render, staticRenderFns }